import { ReactNode } from 'react';
import styles from './Button.module.scss';
import { Icon } from '../Icon';
import clsx from 'clsx';

interface IButton {
  label?: string;
  variant?: 'primary' | 'general' | 'secondary' | 'icon-only' | 'primary-small' | 'general-small' | 'ghost' | 'custom';
  iconName?: string;
  children?: ReactNode | ReactNode[];
  className?: string | string[];
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  iconSize?: string
}

export const Button = ({ label, variant, iconName, children, className, disabled, onClick, type, iconSize }: IButton) => {

  return (
    <button type={type} className={clsx(styles.button, className)} data-variant={variant} disabled={disabled} onClick={onClick}>
      {label && <span className={styles.label}>{label}</span>}
      {iconName && <Icon name={iconName} size={iconSize} />}
      {children}
    </button>
  );
};
